export default __webpack_public_path__ + "static/media/chat-block1.7f1a051a.png";